import React from 'react'

const SvgRollerBrushFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M5 2a2 2 0 00-2 2v3a2 2 0 002 2h11a2 2 0 002-2 1 1 0 011 1v1.85a1 1 0 01-1 1h-5a3 3 0 00-3 3V15H9v5a2 2 0 104 0v-5h-1v-1.15a1 1 0 011-1h5a3 3 0 003-3V8a3 3 0 00-3-3V4a2 2 0 00-2-2H5z' />
  </svg>
)

export default SvgRollerBrushFilled
